export default __webpack_public_path__ + "static/media/pageNotFound.947bae3f.svg";